import { apiClient } from './api-client'

// For backward compatibility
export const api = apiClient
// Also export the apiClient directly
export { apiClient }
